<template>
  <div>
  <div class="looking_site" v-if="!isApply">
    <van-nav-bar title="申请成为超级会员" left-arrow @click-left="goback()" />

    <van-image width="100%" src="/static/images/partner.jpg" height="200" fit="cover" />

    <div class="site_form">
      <van-form label-width="120" :show-error="false" @submit="onSubmit" error-message-align="right">
        <van-cell-group>
          <van-field input-align="right" required v-model="submitData.company" label="公司名称" placeholder="请输入"
            :rules="[{ required: true, message: '请输入公司名称' }]" />

          <van-field input-align="right" required v-model="submitData.contactName" label="您的姓名" placeholder="请输入"
            :rules="[{ required: true, message: '请输入您的姓名' }]" />

          <van-field input-align="right" required v-model="submitData.contactNumber" label="联系电话" placeholder="请输入"
            :rules="[
              { required: true, message: '请输入联系电话' },
              { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
            ]" />

          <van-field v-model="submitData.remark" rows="2" autosize type="textarea" placeholder="请简单描述你的场地情况（选填）"
            show-word-limit label-width="100" />
        </van-cell-group>

        <van-radio-group v-model="newvalue">
          <van-radio name="0" @click="dyDeselect(0)">我已阅读并同意 <span style="color: #2295ff"
              @click="userAgreement">【用户协议】</span>
          </van-radio>
        </van-radio-group>

        <div class="form_btn">
          <van-button block color="#2295FF" type="info" native-type="submit">立即提交</van-button>
        </div>
      </van-form>
    </div>
  </div>

    <div class="submitLookingSite" v-if="isApply">
        <img src="/static/images/success.jpg" />
        <div class="m-t20 fs17" style="color: #0ca309">{{applyStatusName}}</div>
        <van-button plain color="#0ca309" size="small" @click="goback()"
          >知道了</van-button
        >
    </div>
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Image, Notify } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Image.name]: Image,
  },
  data() {
    return {
      submitData: {
        company: "",
        contactName: "",
        contactNumber: "",
        remark: "",
      },
      newvalue: null, //当前值
      oldvalue: null,
      isApply: false, //是否申请
    };
  },

  created() {
    this.getStatus()
    //this.getInfo()
  },

  methods: {
    dyDeselect(index) {
      // 判断当前值和旧的值是否相等
      if (index === this.oldvalue) {
        this.newvalue = null;
        this.oldvalue = null;
      } else {
        this.oldvalue = index;
      }
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        //this.$router.go(-1);
        this.$router.push({ path: "/personal/index" });
      }
    },

    userAgreement() {
      this.$router.push({ path: "/personal/userAgreement" });
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      this.showType = false;
    },

    // 选中注册
    onSelectRegister(item) {
      this.showRegister = false;
    },

    //提交申请场地
    onSubmit() {
      var that = this;
      if (that.newvalue != null) {
        that.$api
          .distributorApplySaveAPI(that.submitData)
          .then(function (res) {
            if (res.data.code === 200) {
              //跳转提交帮我找场地表单成功界面
              that.$router.push({ path: "/home/submitLookingSite" });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
      } else {
        Notify({ type: "warning", message: "请点击同意场地协议！" });
        return;
      }
    },

    //获取分销商主页信息
    getInfo(){
      var that = this;
      that.$api
        .distributorIndexAPI('')
        .then(function (res) {
          if (res.data.code === 200) {
            that.isApply = true;
            that.applyStatusName = '您已是分销商用户';
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //获取超级会员申请状态
    getStatus(){
      var that = this;
      that.$api
        .getStatus('')
        .then(function (res) {
          if (res.data.code === 200) {
            switch(res.data.data){
              case "1":
                that.applyStatusName = '您已有待审核记录，请耐心等待';
                that.isApply = true;
                break;
              case "2":
                that.applyStatusName = '您已是分销商用户';
                that.isApply = true;
                break;
              case "3":
                that.isApply = false;
                that.getInfo()
                break;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .van-field {
      /deep/ textarea {
        height: 100px !important;
        background: #f4f3f8;
        padding: 5px;
      }
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 110px;
        color: #ee0a24;
        margin-top: 5px;
        font-size: 8px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .van-radio-group {
    margin: auto;
    margin-top: 40px;
    font-size: 13px;
    display: flex;
    justify-content: center;
  }

  .form_btn {
    margin: 40px 10px;

    .van-button {
      height: 44px;
    }
  }
}

.submitLookingSite {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 50px 0px;
  font-size: 14px;

  .van-button {
    width: 150px;
    font-size: 14px;
    position: absolute;
    bottom: 50px;
    border-radius: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/personal/superMembers.vue